import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Search } from 'src/components';
import { fetchInventory } from 'src/redux/action/inventory.action';
import { RootState } from 'src/redux/reducers';
import InvenTable from './InvenTable';

interface IProps {}

const Inventory: React.FC<IProps> = ({}) => {
  const [query, setQuery] = React.useState('');
  const dispatch = useDispatch();

  const { inventoryData } = useSelector(
    ({ inventoryData }: RootState) => inventoryData,
    shallowEqual
  );

  React.useEffect(() => {
    if (inventoryData.length > 0) return;
    dispatch(fetchInventory() as any);
  }, [dispatch]);

  const searchInventoryData =
    inventoryData && Object.keys(inventoryData).length > 0
      ? inventoryData.filter((item) => {
          if (query === '') {
            return item;
          } else if (item) {
            return item?.name?.toLowerCase().includes(query.toLowerCase());
          }
        })
      : [];

  return (
    <>
      <div className="grid grid-cols-12 gap-5">
        <div className="col-span-12">
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search item"
              query={query}
              setQuery={setQuery}
            />
          </div>
          <div className="grid text-black">
            <InvenTable tableData={searchInventoryData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Inventory);
